export default __webpack_public_path__ + "static/media/client-cred.4711f033.webp";